import React from 'react';

import { Box } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import { IServerOrder } from '@rbi-ctg/menu';
import useAuth from 'hooks/auth/use-auth';
import useOrderNumber from 'hooks/use-order-number';
import PickupCard from 'pages/order-confirmation/pickup-card';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import OrderConfirmationHeaderProgress from './order-confirmation-header-progress';
import {
  Container,
  Header,
  ImHereText,
  Instructions,
  OrderNumber,
  PickupCardContainer,
} from './styled';
import { getOrderConfirmationHeader, getOrderConfirmationInstructions } from './utils';

interface IOrderConfirmationHeader {
  serverOrder: IServerOrder;
  showProgress?: boolean;
  needConfirm?: boolean;
  setNeedConfirmation?: (value: boolean) => void;
  setProcessingPayment?: (value: boolean) => void;
}
const OrderConfirmationHeader = ({
  serverOrder,
  showProgress,
  needConfirm,
  setNeedConfirmation,
  setProcessingPayment,
}: IOrderConfirmationHeader) => {
  const { user } = useAuth();
  const { formatMessage } = useIntl();
  const orderNumber = useOrderNumber(serverOrder);
  const isMobileOrderForDriveThruLaneEnabled = useFlag(
    LaunchDarklyFlag.ENABLE_MOBILE_ORDER_DRIVE_THRU_LANE
  );
  const formatedOrderNumber = formatMessage({ id: 'orderConfirmationNumber' }, { orderNumber });
  const serviceMode = serverOrder.cart.serviceMode;
  const userName = (user?.details.name ?? '').split(' ')[0];
  const imHereText = formatMessage({ id: 'imHere' });

  const headerText = getOrderConfirmationHeader({ userName, needConfirm, formatMessage });
  const instructions = getOrderConfirmationInstructions({
    userName,
    serviceMode,
    needConfirm,
    formatMessage,
    imHere: <ImHereText>{imHereText}</ImHereText>,
    isMobileOrderForDriveThruLaneEnabled,
  });

  return (
    <Box>
      {showProgress && <OrderConfirmationHeaderProgress needConfirm={needConfirm} />}
      <Container>
        {orderNumber && <OrderNumber focusable>{formatedOrderNumber}</OrderNumber>}
        {!!headerText && !!userName && <Header focusable>{headerText}</Header>}
        <Instructions focusable>{instructions}</Instructions>

        {needConfirm && (
          <PickupCardContainer>
            <PickupCard
              serverOrder={serverOrder}
              setNeedConfirmation={setNeedConfirmation}
              setProcessingPayment={setProcessingPayment}
              needConfirm={needConfirm}
            />
          </PickupCardContainer>
        )}
      </Container>
    </Box>
  );
};

export default OrderConfirmationHeader;
